import { z } from 'zod'

import { EDurationID } from '~/features/guild/contract/enums'
import { verificationCodeSchema } from '~/shared/schemas/verification-code-schema'

export const ContractInput = z.object({
  duration: z.nativeEnum(EDurationID).optional(),
  code: verificationCodeSchema,
})
